import React from "react";

// Sentry calls a function fallback directly from its class render method. Keep
// this renderer hook-free so handling the original exception cannot trigger the
// React invalid-hook-call error (#321).
function ErrorBoundary({ error, componentStack, resetError }) {
  const details =
    componentStack || error?.stack || error?.message || String(error || "");

  return (
    <div className="card my-5">
      <div className="card-header">
        <p>
          Ocorreu um erro ao carregar esta página.
          <button
            type="button"
            className="btn btn-link tw-p-0 tw-ml-1"
            onClick={() => {
              resetError?.();
              window.location.reload();
            }}
          >
            Recarregar página
          </button>
        </p>
      </div>
      {details && (
        <div className="card-body">
          <details className="error-details">
            <summary>Ver detalhes do erro</summary>
            <pre className="tw-whitespace-pre-wrap tw-text-xs">{details}</pre>
          </details>
        </div>
      )}
    </div>
  );
}

export default ErrorBoundary;
